module.exports = __webpack_public_path__ + "static/Sonyax58-0a69987c5560c0ebdb7e0af36e1216ef.png";